import { memo } from 'react';
import PropTypes from 'prop-types';

const RateRulesDescription = ({ rateOptionRules }) =>
  rateOptionRules ? (
    rateOptionRules.map((rule) => (
      <div key={rule.text} className="whitespace-normal">
        <div className="font-bold my-2">{rule.rateOptionRule}</div>
        <pre className="ml-5 whitespace-pre-wrap">{rule.text}</pre>
      </div>
    ))
  ) : (
    <></>
  );

RateRulesDescription.propTypes = {
  rateOptionRules: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default memo(RateRulesDescription);
